export const MAX_NUMBER_OF_TICKETS_HELD = 100_000;
export const MAX_NUMBER_OF_TICKETS_WASTED = 500;
